import { i18n } from "commonAssets/js/constants";
import { createElement } from "./createElement.js";

/**
 * Modal Helper
 * @param {*} title
 * @param {*} body
 * @param {*} footerElems a list of elements to include in the footer
 */
export function modal(title, body, footerElems = []) {
    // create modal container
    const modalContainer = createElement("div", {
        class: "modal fade",
        tabindex: "-1",
        role: "dialog",
    });

    // create modal dialog
    const modalDialog = createElement("div", {
        class: "modal-dialog modal-dialog-centered",
        role: "document",
    });

    // create modal content
    const modalContent = createElement("div", { class: "modal-content" });

    // create modal header
    const modalHeader = createElement("div", { class: "modal-header" }, [
        createElement("h5", { class: "modal-title" }, [], title),
        createElement(
            "button",
            {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close",
            },
            []
        ),
    ]);

    // create modal body
    const modalBody = createElement("div", { class: "modal-body" }, [], body);

    const modalFooterElems = [
        createElement(
            "button",
            {
                type: "button",
                class: "btn btn-secondary",
                "data-bs-dismiss": "modal",
            },
            [],
            i18n.getTranslation("close")
        ),
        ...footerElems,
    ];

    // create modal footer
    const modalFooter = createElement(
        "div",
        { class: "modal-footer" },
        modalFooterElems
    );

    // add header, body, and footer to content
    modalContent.appendChild(modalHeader);
    modalContent.appendChild(modalBody);
    modalContent.appendChild(modalFooter);

    // add content to dialog
    modalDialog.appendChild(modalContent);

    // add dialog to container
    modalContainer.appendChild(modalDialog);

    // Add modal to DOM first
    document.body.appendChild(modalContainer);

    // remove from DOM if fully closed
    modalContainer.addEventListener("hidden.bs.modal", () => {
        modalContainer.remove();
    });

    // show modal with proper Bootstrap reference
    try {
        // Check for Bootstrap availability in different scopes
        const Bootstrap =
            (typeof window !== "undefined" && window.bootstrap) ||
            (typeof bootstrap !== "undefined" && bootstrap) ||
            null;
        if (Bootstrap && Bootstrap.Modal) {
            const modalInstance = new Bootstrap.Modal(modalContainer);
            modalInstance.show();
        } else {
            // Fallback: try to show modal without JS (CSS-only)
            console.warn(
                "Bootstrap JavaScript not available, falling back to CSS-only modal"
            );
            modalContainer.classList.add("show");
            modalContainer.style.display = "block";
            modalContainer.setAttribute("aria-modal", "true");
            modalContainer.removeAttribute("aria-hidden");

            // Add backdrop
            const backdrop = document.createElement("div");
            backdrop.className = "modal-backdrop fade show";
            document.body.appendChild(backdrop);

            // Handle close buttons
            modalContainer
                .querySelectorAll('[data-bs-dismiss="modal"]')
                .forEach((button) => {
                    button.addEventListener("click", () => {
                        modalContainer.classList.remove("show");
                        modalContainer.style.display = "none";
                        modalContainer.setAttribute("aria-hidden", "true");
                        modalContainer.removeAttribute("aria-modal");
                        backdrop.remove();
                        modalContainer.remove();
                    });
                });
        }
    } catch (error) {
        console.error("Error initializing Bootstrap modal:", error);
        // Fallback behavior
        modalContainer.classList.add("show");
        modalContainer.style.display = "block";
    }
}
